

import md5 from './md5'
import { host } from './hostConf'
export function getSign(params) {
  // 如果入参有undefined，统一置为""
  if (!params) return params;
  for (let item in params) {
    if (params[item] == undefined) {
      params[item] = ''
    }
  }
  params.timestamp = new Date().getTime().toString()
  //生成key升序数组
  var arr = Object.keys(params)
  let str = ""
  arr.sort()
  for (var i in arr) {
    if (typeof(params[arr[i]]) == 'object') {
      str += ''
    } else {
      str += params[arr[i]]
    }
  }
  // 登录成功后的token
  params.sign = md5(str + host.appkey);

  return params
}